import StakeDiclaimer from './StakeDiclaimer';

export default StakeDiclaimer;
